export default "__VITE_ASSET__CIcfkZUH__"